export default {
  from: {
    width: '80%'
  },
  received: {
    width: '80px'
  },
  context: {
    width: '40px',
    height: '40px !important',
    borderRadius: '5px',
    display: 'inline-block'
  }
}
